class HbsRaportiptanimDTO {
    id: number = null;
    organizasyonId?: number = null;
    adi?: string = "";
    islemsecimzorunlu?: string = "E";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "H";
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
    protokolGrupId?: number = null;
    rapormodultip?: number = 1;
}
export default HbsRaportiptanimDTO;